import type { IMarketData } from "@stepfinance/common";

export type SerumMarketPrices = {
  bid: number | null;
  ask: number | null;
  mid: number | null;
};

export type SerumMarketData = Omit<IMarketData, "metadata"> & {
  metadata: {
    marketPrices: SerumMarketPrices;
  };
};

export const isSerumMarketData = (marketData: IMarketData | undefined): marketData is SerumMarketData =>
  marketData?.source === "serum" && typeof marketData.metadata?.marketPrices === "object";

export const getSerumMarketPrices = (marketData: IMarketData | undefined): SerumMarketPrices => {
  let serumMarketPrices: SerumMarketPrices = {
    bid: marketData?.price ?? null,
    mid: marketData?.price ?? null,
    ask: marketData?.price ?? null,
  };

  if (isSerumMarketData(marketData)) {
    serumMarketPrices = marketData.metadata.marketPrices;
  }

  return serumMarketPrices;
};
